import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { getOwner } from '../../libraries/utils';
import { ToastContainer, notify } from "../../libraries/notifications";

import { history } from '../../routes';
import config from "../../config";

import appointmentsActions from "../../context/appointments/actions";

import Loader from '../../components/commons/Loader';
import Icon from "../../libraries/icons";
import LayoutWithSidebar from "../../components/layout/LayoutWithSidebar";
import AppointmentCard from "../../components/customs/AppointmentCard";
import SearchInput from "../../components/forms/SearchInput";

class MyAppointments extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      appointments: [],
      history: [],
      search: "",
    };
  }

  componentDidMount() {
    console.log("MY APPOINTMENTS PAGE");
    this.getAppointments();
  }

  getAppointments = async () => {
    const {search, filters} = this.state
    const params = { target: getOwner(this.props.auth.user), type: config.TRANSACTIONS.BOOK.TYPE, where: {} }
    
    if (search && search !== "") {
      params.where = {"json_data":[]};
      params.where.json_data.push({"field":"professional_name", "value":`%${search.toLowerCase()}`, "comparison":"LIKE"})
    }
    //if(values.search !== "") params.name = values.search
    
    //if (search && search !== ""){
    //  params.where = { name: search }
    //}

    //if (search && search !== "") {
    //  params.where = {"professional":[]};
    //  params.where.professional.push({"field":"name","value":search,"comparison": "LIKE"})
    //}

    await this.props.onGetAllAppointments(params);
    const { appointments } = this.props;
    if (appointments.error) {
      notify(this.t(appointments.error.message));
    } else {
      this.setState({
        appointments: appointments.items.filter((a) => (
          [config.TRANSACTIONS.BOOK.STATUS.BOOKED, config.TRANSACTIONS.BOOK.STATUS.IN_PROGRESS].includes(a.status)
          && (new Date() <= new Date(a.date))
        )),
        history: appointments.items.filter((a) => (
          [config.TRANSACTIONS.BOOK.STATUS.CANCELED, config.TRANSACTIONS.BOOK.STATUS.COMPLETED].includes(a.status)
          || (new Date() > new Date(a.date))
        )).reverse(),
      });
    }
  };

  searchClear = (form) => {
    form.change('search', undefined);
    this.searchOnClick({search: ''});
  }

  searchOnClick = async (values) => {
    console.log("Search on Click", values.search);
    if (this.state.search !== values.search) this.setState({ search: values.search || '' }, () => this.getAppointments() );
  };

  gotoBack = () => {
    history.push(config.ROUTES.HOME);
  }

  render() {
    const { appointments, history } = this.state;

    return (
      <LayoutWithSidebar
        main={{ className: "bg-base-200" }}
        header={{
          title: this.t("Consultas Profesionales"),
        }}
        container={{ className: "px-0" }}
      >
        <ToastContainer />
        <section className="h-10 bg-primary"></section>
        <section className="section-card">
          <Form initialValues={{}} onSubmit={this.searchOnClick}>
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto mb-4">
                <Field name="search" component={SearchInput} placeholder={this.t("Search")} onClick={this.searchOnClick} onClearClick={() => this.searchClear(form) }/>
              </form>
            )}
          </Form>
          <div className="mb-10">
            <h2 className="px-4 mb-2">{this.t("Próximas consultas")}</h2>
            { this.props.appointments.loading && (<Loader containerClassName="mt-10"/>) }
            {!this.props.appointments.loading && appointments.length === 0 && (
              <div className="text-center p-10">
                <Icon className="h-24 w-24 mx-auto mb-3" name="stethoscope" />
                <h4 className="mb-1">{this.t("No hay consultas")}</h4>
              </div>
            )}
            {appointments.map((appointment, index) => {
              return(
                <AppointmentCard
                  key={index}
                  route={`${config.ROUTES.APPOINTMENTS.DETAIL.replace(':id', appointment.id)}`}
                  appointment={appointment}
                />)
            })}
          </div>
          <div>
            {history.length > 0 && <h2 className="px-4 mb-2">{this.t("Historial")}</h2>}
            {history.map((h, index) => {
              return(
                <AppointmentCard
                  key={index}
                  route={`${config.ROUTES.APPOINTMENTS.DETAIL.replace(':id', h.id)}`}
                  appointment={h}
                />)
            })}
          </div>
        </section>
      </LayoutWithSidebar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.users.auth,
    appointments: state.appointments.list,
    appointment: state.appointments.current,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetAllAppointments: (params) => dispatch(appointmentsActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MyAppointments));
